import axios from "axios";
import APP_CONSTANTS from "../../config/constants";

//import FormData from 'form-data';
export const PostFilesAxios = async function (props = {}) {
  let token = localStorage.getItem("isloggedIn");
  let userId = localStorage.getItem("userId");
  let customerNo = localStorage.getItem("customerNumber");

  let formData = new FormData();
  formData.append("customerNo", customerNo);
  formData.append("customerNumber", customerNo);
  formData.append("userId", userId);

  formData.append("orderNo", props.createItems.orderNo);
  formData.append("deliveryNo", props.createItems.deliveryNo);
  formData.append("documentName", props.createItems.documentName);
  formData.append("documentContent", props.createItems.documentContent);
  formData.append("document", props.createItems.documentContent);

  var config = {
    method: 'put',
    url: `${APP_CONSTANTS.BASE_URL}${props.url}`,
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'multipart/form-data',
      Authorization: `${token}`,
    },
    data: formData
  };

  try {
    return new Promise((resolve, reject) => {
      axios(config)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  } catch (error) {
    return console.log("Error Create", error);
  }
};

export default PostFilesAxios

export const PatchFilesAxios = async function (props = {}) {
  let token = localStorage.getItem("isloggedIn");
  let userId = localStorage.getItem("userId");
  let customerNo = localStorage.getItem("customerNumber");

  let formData = new FormData();
  formData.append("customerNo", customerNo);
  formData.append("customerNumber", customerNo);
  formData.append("userId", userId);

  formData.append("orderNo", props.createItems.orderNo);
  formData.append("deliveryNo", props.createItems.deliveryNo);
  formData.append("documentName", props.createItems.documentName);
  formData.append("documentContent", props.createItems.documentContent);

  var config = {
    method: 'patch',
    url: `${APP_CONSTANTS.BASE_URL}${props.url}`,
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'multipart/form-data',
    },
    data: formData
  };
  axios(config)
    .then((res) => { console.log(res) })
    .catch((err) => { console.log(err) })
};
